import { render, staticRenderFns } from "./changeCourse.vue?vue&type=template&id=13b9be72&scoped=true&"
import script from "./changeCourse.vue?vue&type=script&lang=js&"
export * from "./changeCourse.vue?vue&type=script&lang=js&"
import style0 from "./changeCourse.vue?vue&type=style&index=0&id=13b9be72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9be72",
  null
  
)

export default component.exports